import { createSelector } from '@reduxjs/toolkit';
import getIn from 'transmute/getIn';
import { getWelcomeMessage } from './getWelcomeMessage';
export const getSpotlightGlowColor = createSelector(getWelcomeMessage, message => getIn(['spotlightConfig', 'glowColor'], message));